import { links } from "data";
import { ExternalLink } from "shared/components";
import { AccordionContainer } from "./accordion-container";
import styles from "./accordions.module.scss";

export const SUPPORT_ACCORDION_KEY = "SUPPORT_ACCORDION_KEY";

export const SupportAccordion = () => {
  return (
    <AccordionContainer accordionKey={SUPPORT_ACCORDION_KEY}>
      <div className="flex gap-sm">
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>How can we help?</span>
          <ExternalLink href={links.CONTACT_US}>Contact us</ExternalLink>
          <ExternalLink href={links.REQUEST_AN_ONLINE_PROFILE}>
            Request an online profile
          </ExternalLink>
          <ExternalLink href={links.TRACK_YOUR_ITEMS}>
            Track your items
          </ExternalLink>
        </div>
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>Guides & resources</span>
          <ExternalLink href={links.HOW_TO_PACKAGE_YOUR_ITEMS}>
            How to package your items
          </ExternalLink>
          <ExternalLink href={links.ALL_ESSENTIAL_RESOURCES}>
            All essential resources
          </ExternalLink>
        </div>
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>Payments & guidance</span>
          <ExternalLink href={links.FUEL_SURCHARGES}>
            Fuel surcharges
          </ExternalLink>
          <ExternalLink href={links.UK_OVERNIGHT}>
            UK Overnight & International charges
          </ExternalLink>
          <ExternalLink href={links.PAYMENT_OPTIONS}>
            Payment options
          </ExternalLink>
        </div>
        <div className={styles.separator} />
        <div className="flex flex-column gap-xs">
          <span className={styles.subtitle}>Find your Service Centre</span>
          <ExternalLink href={links.LONDON}>London</ExternalLink>
          <ExternalLink href={links.BIRMINGHAM}>Birmingham</ExternalLink>
          <ExternalLink href={links.MANCHESTER}>Manchester</ExternalLink>
          <ExternalLink href={links.ALL_SERVICE_CENTRES}>
            All Service Centres
          </ExternalLink>
        </div>
      </div>
    </AccordionContainer>
  );
};
